import CustomBottom from "../../components/CustomBottom";
import CustomHeader from "../../components/CustomHeader";
import React from "react";

export default function TextileLab() {
  const textDetail = [
    {
      title:
        "เครื่องมือทดสอบตามมาตรฐาน ISO, AATCC  เครื่องทดสอบ SDL Atlas จากสหรัฐอเมริกา  เป็นเครื่องมือเฉพาะสำหรับทดสอบสิ่งทอ เพื่อพัฒนาคุณภาพสิ่งทอพื้นเมืองให้มีประสิทธิภาพและยั่งยืน",
      subTitle: [],
    },
    {
      title:
        "พัฒนาศักยภาพ เพิ่มขีดความสามารถแก่สิ่งทอพื้นเมืองแก่ชุมชนท้องถิ่น สำหรับมาตรฐานมผช. มอก. และมาตรฐาน Circular design พร้อมให้คำปรึกษาครบวงจร",
      subTitle: [],
    },
    {
      title: "ตรวจทดสอบตามมารฐานการทดสอบ",
      subTitle: [
        "ด้านกายภาพ : การเปลี่ยนแปลงขนาดหลังการซัก แรงดึงและการยืดสูงสุด จำนวนเส้นด้าย",
        "ด้านความคงทนของสี : เหงื่อกรดเหงื่อด่าง การซักด้วยสบู่ น้ำ และการขัดถู",
        "ด้านการพัฒนาเส้นใยจากวัสดุต่าง ๆ :  เส้นใยกก เส้นใยตะไคร้ เส้นใยกล้วย เส้นใยผักตบชวา เส้นใยจากขวดน้ำพลาสติก",
        "ด้านนวัตกรรมเทคโนโลยีในการตกแต่งคุณสมบัติพิเศษให้แก่สิ่งทอ : ต้านเชื้อแบคทีเรีย กันยูวี สะท้อนน้ำ มีกลิ่นหอม กันไฟลาม",
      ],
    },
    {
      title: "การทดสอบทางกายภาพ ( Physical test)",
      subTitle: [
        "ทดสอบชนิดเส้นใย (Fiber Identification)",
        "ทดสอบแรงดึงสูงสุดและการยืดที่แรงดึงสูงสุด (Determination of Maximum Force and Elongation at Maximum Force)",
        "มวลผ้าต่อหน่วยพื้นที่ (Mass Per Unit Area)",
        "ขนาดเส้นด้าย (Yarn Number)",
        "จำนวนเส้นด้ายต่อหน่วยความยาว",
        "การเปลี่ยนแปลงขนาดหลังการซัก (Dimensional Stability to Washing) 1-3 รอบ",
      ],
    },
    {
      title: "การทดสอบทางเคมี ( Chemical Testing)",
      subTitle: ["ความเป็นกรด-ด่าง (pH Value)"],
    },
    {
      title: "การทดสอบความคงทนสี (Colour Fastness)",
      subTitle: [
        "การซัก (To Washing)",
        "เหงื่อเทียม (To Persporation)",
        "น้ำ (To Water)",
        "ขัดถู (To Rubbing)",
      ],
    },
  ];
  const fileDownload = [
    {
      name: "เเบบฟอร์มลงทะเบียนสมาชิก",
      link: "/pdf/FM01.pdf",
    },
    {
      name: "เเบบฟอร์มลงทะเบียนลูกค้าใหม่",
      link: "/pdf/FN01.pdf",
    },
    {
      name: "เเบบฟอร์มใบคำขอใช้บริการการทดสอบ",
      link: "/pdf/FT01.pdf",
    },
    {
      name: "อัตราค่าบริการการทดสอบ",
      link: "/pdf/อัตราค่าบริการ.pdf",
    },
    {
      name: "อัตราค่าบริการใช้เครื่องมือวิทยาศาสตร์ ของศูนย์ปฏิบัติการทดสอบวิเคราะห์ผ้าและสิ่งทอ",
      link: "/pdf/อัตราค่าบริการใช้เครื่องมือ.pdf",
    },
  ];
  return (
    <div className="fade_In">
      <CustomHeader />
      <div className="flex flex-row items-center gap-4  pt-[180px]">
        <div className="  absolute left-[10vw]">
          <p className="font-medium text-[20px] text-[#B36427]">
            ห้องปฏิบัติการ
          </p>
          <p className="font-bold text-[32px] sm:text-[64px]">FTCDC LAB</p>
        </div>
        <img src="/img/bgGreen.png" className="w-full object-contain" />
      </div>
      <div className="px-[10vw] py-[24px] flex flex-col gap-5">
        <div className="relative flex flex-col gap-5">
          <p className="text-[22px] sm:text-[36px] font-bold  text-[#B36427]">
            Fabric and Textile Analytical
            <br />
            Testing Laboratory (FTCDC LAB)
          </p>
          <div className="grid grid-cols-2 gap-1">
            <img
              src="/img/texttilelab7.jpg"
              className="w-full object-contain  self-center"
            />
            <img
              src="/img/texttilelab8.jpg"
              className="w-full object-contain  self-center"
            />
          </div>
          <img
            src="/img/texttilelab2.jpg"
            className="w-[25vw] object-contain  self-center"
          />

          <p className=" text-[20px] font-medium">
            ห้องปฏิบัติการทดสอบวิเคราะห์ผ้าและสิ่งทอ
            ศูนย์ออกกแบบสร้างสรรค์ผ้าและสิ่งทอ
            (FTCDC)  มหาวิทยาลัยราชภัฏอุดรธานี
          </p>
          {textDetail.map((item, i) => {
            if (i < 2)
              return (
                <div key={i} className={"flex flex-col gap-3 text-lg "}>
                  <div className=" flex flex-row items-center gap-[20px] pl-[10px]">
                    <div className="w-[10px] h-[10px] bg-[#2E2E2E] rounded-full" />
                    <p className="flex-[1]">{item.title}</p>
                  </div>
                  {item.subTitle.map((subItem, j) => {
                    return (
                      <div
                        key={j}
                        className=" flex flex-row items-center gap-[20px] pl-[42px]"
                      >
                        <div className="w-[10px] h-[10px] border-[#2E2E2E] border rounded-full" />
                        <p className="flex-[1]">{subItem}</p>
                      </div>
                    );
                  })}
                </div>
              );
          })}
          <img
            src="/img/texttilelab3.jpg"
            className="w-[40vw] object-contain  self-center"
          />
          {textDetail.map((item, i) => {
            if (i == 2)
              return (
                <div key={i} className={"flex flex-col gap-3 text-lg "}>
                  <div className=" flex flex-row items-center gap-[20px] pl-[10px]">
                    <div className="w-[10px] h-[10px] bg-[#2E2E2E] rounded-full" />
                    <p className="flex-[1]">{item.title}</p>
                  </div>
                  {item.subTitle.map((subItem, j) => {
                    return (
                      <div
                        key={j}
                        className=" flex flex-row items-center gap-[20px] pl-[42px]"
                      >
                        <div className="w-[10px] h-[10px] border-[#2E2E2E] border rounded-full" />
                        <p className="flex-[1]">{subItem}</p>
                      </div>
                    );
                  })}
                </div>
              );
          })}
          <img
            src="/img/texttilelab4.jpg"
            className="w-[40vw] object-contain  self-center"
          />
          {textDetail.map((item, i) => {
            if (i > 2)
              return (
                <div key={i} className={"flex flex-col gap-3 text-lg "}>
                  <div className=" flex flex-row items-center gap-[20px] pl-[10px]">
                    <div className="w-[10px] h-[10px] bg-[#2E2E2E] rounded-full" />
                    <p className="flex-[1]">{item.title}</p>
                  </div>
                  {item.subTitle.map((subItem, j) => {
                    return (
                      <div
                        key={j}
                        className=" flex flex-row items-center gap-[20px] pl-[42px]"
                      >
                        <div className="w-[10px] h-[10px] border-[#2E2E2E] border rounded-full" />
                        <p className="flex-[1]">{subItem}</p>
                      </div>
                    );
                  })}
                </div>
              );
          })}
        </div>

        {fileDownload.map((item, i) => {
          return (
            <a
              key={i}
              href={item.link}
              target="_blank"
              className="flex flex-row items-center gap-5 text-[#B36427]  font-bold"
            >
              <img
                src="/img/icon_news.png"
                className="w-[40px] object-contain"
              />
              <p>{item.name}</p>
            </a>
          );
        })}
      </div>
      <CustomBottom />
    </div>
  );
}
